module.exports = __webpack_public_path__ + "img/a428ac133da14dfaa06798f9928c7180.png";